import React from 'react';
import PortfolioPage from './PortfolioPage'; // Adjust path as needed

function App() {
  return <PortfolioPage />;
}

export default App;
